
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';

const resources = {
    en: {
        translation: {
            ...translationEN
        }
    },
    pt: {
        translation: {
            ...translationPT
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'pt',
        supportedLngs: ['pt', 'en'],
        nonExplicitSupportedLngs: true,
        debug: false,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;

// Keep screen readers and browser language tools aligned with the visible menu.
const updateDocumentLanguage = (language: string) => {
    document.documentElement.lang = language.split('-')[0] ?? 'pt';
};
i18n.on('languageChanged', updateDocumentLanguage);
updateDocumentLanguage(i18n.language ?? 'pt');
